import { CardsGrid } from '../styles/InstitutionalViewStyles';
import MissionVisionCard from './MissionVisionCard';

const MissionVisionCards = () => {
  return (
    <CardsGrid>
      <MissionVisionCard
        type="mission"
        icon="fa-solid fa-rocket"
        titleIcon="fa-solid fa-bullseye"
        title="Nuestra Misión"
        description="Somos una Comunidad contagiosa de amor que sigue el sueño de Jesús de ver las multitudes hechas discípulos en el río del Espíritu Santo."
      />
      <MissionVisionCard
        type="vision"
        icon="fa-solid fa-eye"
        titleIcon="fa-solid fa-mountain-sun"
        title="Nuestra Visión"
        description="Ser una comunidad contagiosa de amor, madura y multiplicadora, formada por multitudes de discípulos de Jesús que, fluyendo en el río del Espíritu Santo, transforman la ciudad y las naciones, trayendo el cielo a la tierra."
      />
    </CardsGrid>
  );
};

export default MissionVisionCards;
